import { LinkTermsPrivacy } from './LinkTermsPrivacy.style';

export default LinkTermsPrivacy;
